export default "__VITE_ASSET__Dt4W6sOd__"